import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class Video {
    constructor() {
        this.createModal();
        this.init();
    }

    init() {
        let videos = document.querySelectorAll( '[data-video]' );
        
        videos.forEach( ( video ) => {
            let videoSrc = video.getAttribute( 'data-video' );

            video.addEventListener( 'click', ( e ) => {
                e.preventDefault();
                let target = video.querySelector( '[data-video-target="' + videoSrc + '"]' );

                if ( null !== target ) {
                    this.modalContent.appendChild( target.cloneNode( true ) );
                } else {
                    const videoWrapper = document.createElement('div');
                    videoWrapper.className = 'video';

                    const videoButton = document.createElement('span');
                    videoButton.className = 'video__button';

                    const video = document.createElement('video');
                    video.src = videoSrc;
                    video.autoplay = false;

                    videoWrapper.appendChild( videoButton );
                    videoWrapper.appendChild( video );
                    this.modalContent.appendChild( videoWrapper );

                    videoButton.addEventListener( 'click', () => {
                        videoWrapper.classList.add( 'playing' );
                        video.play();
                    } );

                    video.addEventListener( 'click', () => {
                        videoWrapper.classList.remove( 'playing' );
                        video.pause();
                    } );
                }

                this.modal.classList.add( 'opened' ); 
                disableBodyScroll( this.modal );
            } );
        } );
    }

    createModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'video-modal';

        this.modalOverlay = document.createElement('div');
        this.modalOverlay.className = 'video-modal__overlay';

        this.modalContent = document.createElement('div');
        this.modalContent.className = 'video-modal__content';

        document.body.appendChild( this.modal );
        this.modal.appendChild( this.modalOverlay );
        this.modal.appendChild( this.modalContent );

        this.modalOverlay.addEventListener( 'click', ( e ) => {
            this.modal.classList.remove( 'opened' );
            this.modalContent.innerHTML = '';
            clearAllBodyScrollLocks();
        } );
    }
}